import ProjectRadarIcon from "assets/svg/components/projectRadar/ProjectRadarSVG";

import EndeksaIcon from "assets/svg/endeksa_logo.svg";
import EstateIcon from "assets/svg/estate-investment-specialist.svg";
import LandIcon from "assets/svg/parcel-of-land.svg";
import NewBadge from "assets/svg/new_badge.svg";

const realEstateColumns = [
  {
    logo: <LandIcon />,
    title: "Aradığın Arsayı Bulamadın Mı?",
    subTitle: "Arsa arıyorsan çözüm net: Emlakjet!",
    badge: <NewBadge />,
    buttonText: "Arsa Dünyasını İncele",
    buttonHref: "/arsa",
    isTopHeadColumn: true,
    media: "/assets/images/youtube-thumbnail.webp",
    isYoutubeComponent: true,
    eventLabel: "arsa-dunyasini-incele",
  },
  {
    logo: <ProjectRadarIcon />,
    title: "Ödeme Avantajlı Sıfır Konut Projeleri",
    subTitle:
      "Fiyat detaylı ve ödeme avantajlı sıfır konut projeleri Proje Radarı'nda! Tıkla, incele, karşılaştır! Hayalindeki ev senin olsun!",
    badge: <NewBadge />,
    buttonText: "Hemen İncele",
    buttonHref: "/proje-radari",
    isTopHeadColumn: true,
    media: "/assets/images/proje-radari-img.webp?v=2",
    isYoutubeComponent: false,
    eventLabel: "gayrimenkul-mu-ariyorsun||proje-radari",
  },
  {
    logo: <EstateIcon />,
    title: "Emlak Yatırım Uzmanı",
    subTitle: "Emlak Yatırımlarınızda Maksimum Kazanç İçin Çözüm Net: Emlakjet!",
    buttonText: "Hemen Başvur",
    buttonHref: "/emlak-yatirim-uzmani",
    eventLabel: "emlak-yatirim-uzmani",
  },
  {
    logo: <EndeksaIcon />,
    title: "Emlak Değerini Öğren!",
    subTitle: "Evinin özelliklerini gir, Endeksa ile hemen değerini öğren.",
    buttonText: "Hesapla",
    buttonHref: "https://www.endeksa.com/tr/emlak-degeri",
    eventLabel: "endeksa-emlak-degerini-ogren",
  },
];

export default realEstateColumns;
